import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as SdsPagination } from "@bookips/sds";
const Pagination = (param)=>{
    let { page , totalCount , pageSize , onChange  } = param;
    const totalPages = Math.ceil(totalCount / pageSize);
    if (totalPages <= 1) return null;
    const handlePageChange = (next)=>{
        onChange(next);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "flex justify-center py-6",
        children: /*#__PURE__*/ _jsx(SdsPagination, {
            totalPages: totalPages,
            currentPage: page,
            onPageChange: handlePageChange,
            shape: "rounded",
            size: "md",
            arrow: true
        })
    });
};
export default Pagination;
